import { render, staticRenderFns } from "./attendance-log.vue?vue&type=template&id=5a74224a&"
import script from "./attendance-log.vue?vue&type=script&lang=js&"
export * from "./attendance-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports